import { useState } from "react";
import { Link } from "react-router-dom";
import VideoCard from "@/components/feature/VideoCard";
import { videos } from "@/mocks/videos";

const PAGE_SIZE = 12;

export default function LatestUpdates() {
  const sorted = [...videos].sort((a, b) => b.year - a.year);
  const [count, setCount] = useState(PAGE_SIZE);
  const visible = sorted.slice(0, count);
  const hasMore = count < sorted.length;

  return (
    <section className="px-4 md:px-8 py-10 md:py-14">
      <div className="flex items-end justify-between gap-4 mb-6 md:mb-8">
        <div>
          <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950">最新更新</h2>
          <p className="mt-1.5 text-sm text-foreground-600">持续上新，第一时间看到新鲜好内容</p>
        </div>
        <span className="text-sm text-foreground-500 whitespace-nowrap">共 {sorted.length} 部</span>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-3 md:gap-5">
        {visible.map((video, i) => (
          <VideoCard key={video.id} video={video} index={i} />
        ))}
      </div>

      {hasMore && (
        <div className="flex justify-center mt-8 md:mt-10">
          <button
            type="button"
            onClick={() => setCount((c) => c + PAGE_SIZE)}
            className="inline-flex items-center gap-2 px-6 py-3 rounded-md font-medium whitespace-nowrap bg-background-200/70 text-foreground-950 hover:bg-background-200 transition-colors cursor-pointer"
          >
            <i className="ri-add-line text-lg" /> 加载更多
          </button>
        </div>
      )}

      <div className="flex justify-center mt-10">
        <Link
          to="/category/movie"
          className="inline-flex items-center gap-2 px-6 py-3 rounded-md font-medium whitespace-nowrap bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer"
        >
          浏览全部分类 <i className="ri-arrow-right-line" />
        </Link>
      </div>
    </section>
  );
}